import { LG_COLOR } from 'containers/App/constants';
import styled from 'styled-components';

export const AssetContainerStyles = styled.div`
  background-color: black;
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  .asset-loader {
    color: ${LG_COLOR};
    height: 100px;
    width: 100px;
  }
`;
